// Import de bibliotecas principais
import React, { Fragment, useEffect, useRef } from 'react'
import { homeData } from '../../../../utils/wordpress/wordpressGetter'

// Import de elementos de estilização, componentes gerais e de layout
// import { motion } from 'framer-motion/dist/framer-motion'
import * as Modules from '../../../../template-parts/modules'
import './Default.module.scss'

function Default({ path }) {
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	let Offset = Modules['OffsetBlock']
	return homeData.nodeByUri.home.modulos ? (
		<Fragment>
			{homeData.nodeByUri.home.modulos.map((wordpressModule, i) => {
				let moduleId = wordpressModule.fieldGroupName
				let Module = Modules[moduleId]
				return (
					<Module
						refMain={path.refMain}
						key={moduleId + i}
						data={wordpressModule}
					></Module>
				)
			})}
			<Offset />
		</Fragment>
	) : (
		<></>
	)
}

export { Default }
